import StoreCategories from './StoreCategories';
export default StoreCategories;
